"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = undefined;

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _themed = require("../../utils/themed");

var _themed2 = _interopRequireDefault(_themed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Flex = exports.Flex = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Flex",
  componentId: "sc-1om2mfw-0"
})(["display:flex;", ""], (0, _themed2.default)("Flex"));

/** @component */
exports.default = Flex;